import Vue from 'vue';
import { Popup, Picker, Area, DatetimePicker, Notify, Dialog, Icon } from 'vant';
import 'vant/lib/index.css';

Vue.use(Picker);
Vue.use(Popup);
Vue.use(Area);
Vue.use(DatetimePicker);
Vue.use(Notify);
Vue.use(Dialog);
Vue.use(Icon);
